import React, { useEffect, Fragment } from 'react';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { FloatingButtons } from '../FloatingButtons';
import { useLanguage } from '../../i18n/LanguageContext';
type Props = {
  titleEs: string;
  titleCa: string;
  subtitleEs: string;
  subtitleCa: string;
  children: React.ReactNode;
};
export function LegalLayout({
  titleEs,
  titleCa,
  subtitleEs,
  subtitleCa,
  children
}: Props) {
  const {
    lang
  } = useLanguage();
  const title = lang === 'es' ? titleEs : titleCa;
  const subtitle = lang === 'es' ? subtitleEs : subtitleCa;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <>
      <Header data-id="element-565" />
      {/* Page Hero */}
      <section className="relative bg-[#1a3a2a] pt-32 pb-12 md:pt-36 md:pb-16 px-6 text-center" data-id="element-566">
        <div className="max-w-3xl mx-auto" data-id="element-567">
          <h1 className="font-serif text-3xl md:text-5xl text-cream mb-4" data-id="element-568">
            {title}
          </h1>
          <div className="w-16 h-[1px] bg-gold mx-auto mb-4" data-id="element-569"></div>
          <p className="text-sage-light text-sm md:text-base" style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: 300
        }} data-id="element-570">
            {subtitle}
          </p>
        </div>
      </section>

      {/* Content */}
      <main className="bg-[#f7f4ef] py-12 md:py-20 px-4 sm:px-6" data-id="element-571">
        <div className="max-w-[800px] mx-auto space-y-4 md:space-y-5" data-id="element-572">
          {children}
        </div>
      </main>

      <Footer data-id="element-573" />
      <FloatingButtons data-id="element-574" />
    </>;
}
type BlockProps = {
  title: string;
  children: React.ReactNode;
};
export function LegalBlock({
  title,
  children
}: BlockProps) {
  return <div className="bg-white border-l-[3px] border-[#c49a4a] rounded-lg p-6 md:p-7 shadow-sm" style={{
    marginBottom: '16px'
  }} data-id="element-575">
      <h2 className="font-serif text-[22px] md:text-[24px] text-[#1a3a2a] mb-4 leading-snug" style={{
      fontFamily: '"Cormorant Garamond", serif'
    }} data-id="element-576">
        {title}
      </h2>
      <div className="text-[15px] leading-[1.7] text-[#2c3e2d] space-y-4" style={{
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400
    }} data-id="element-577">
        {children}
      </div>
    </div>;
}
type InfoGridProps = {
  items: {
    label: string;
    value: string;
  }[];
};
export function InfoGrid({
  items
}: InfoGridProps) {
  return <div className="mt-5 grid grid-cols-1 sm:grid-cols-[140px_1fr] gap-x-6 gap-y-3 text-[14px] bg-[#f7f4ef]/60 p-5 rounded-md border border-sage-light/20" data-id="element-578">
      {items.map((item, i) => <Fragment key={i} data-id="element-579">
          <div className="font-medium text-[#8a9e7a] uppercase tracking-wider text-[12px]" style={{
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-580">
            {item.label}
          </div>
          <div className="text-[#1a3a2a] break-words" data-id="element-581">{item.value}</div>
        </Fragment>)}
    </div>;
}
type IconListProps = {
  items: string[];
};
export function IconList({
  items
}: IconListProps) {
  return <ul className="space-y-2 mt-3" data-id="element-582">
      {items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-583">
          <span className="text-[#c49a4a] mt-0.5 flex-shrink-0" data-id="element-584">✦</span>
          <span data-id="element-585">{item}</span>
        </li>)}
    </ul>;
}